import {
  getIssuingAccountAdmin,
  useIsAdminRole,
  useIsManagerRole,
} from '@easy-expense/data-firestore-client';
import Data from '@easy-expense/frontend-data-layer';
import { IconName } from '@easy-expense/ui-shared-components';

import { SETTINGS_BILLING_ROUTE } from '../lib/Billing/constants';

export const Routes = [
  ...[
    { icon: 'receipt', name: 'Transactions', route: '/transactions' },
    { icon: 'car', name: 'Drives', route: '/drives' },
    { icon: 'bar-chart', name: 'Reports', route: '/reports' },
  ],
  ...(getIssuingAccountAdmin() ? [{ icon: 'card', name: 'Stripe Card', route: '/issuing' }] : []),
  ...[{ icon: 'cloud-download', name: 'Export', route: '/export' }],
  ...[{ icon: 'wallet', name: 'Billing', route: SETTINGS_BILLING_ROUTE }],
] as { icon: IconName; name: string; route: 'string' }[];

export const useAppRoutes = () => {
  const isAdmin = useIsAdminRole();
  const isManager = useIsManagerRole();
  const canManageTeam = isAdmin || isManager;
  const trips = Data.trips.use();

  return [
    ...[
      { icon: 'receipt', name: 'Transactions', route: '/transactions' },
      ...(trips.length > 0 ? [{ icon: 'car', name: 'Drives', route: '/drives' }] : []),
      { icon: 'bar-chart', name: 'Reports', route: '/reports' },
    ],
    ...(getIssuingAccountAdmin() ? [{ icon: 'card', name: 'Stripe Card', route: '/issuing' }] : []),
    ...[{ icon: 'cloud-download', name: 'Export', route: '/export' }],
    ...(canManageTeam ? [{ icon: 'person-add', name: 'Manage Team', route: '/workspace' }] : []),
    ...[{ icon: 'documents', name: 'Reconcile', route: '/reconcile' }],
    ...[{ icon: 'wallet', name: 'Billing', route: SETTINGS_BILLING_ROUTE }],
    ...[{ icon: 'hammer', name: 'Settings', route: '/settings' }],
  ] as { icon: IconName; name: string; route: 'string' }[];
};
